import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { Event, NewEvent, NewEventOrgan, Organ, UnscheduledEvents } from '../store/calendar.models';
import {
  ExternalOptions,
  fetchEventsProps,
  FetchExternalOptionsProps,
  FetchRepeatOptionsProps,
  RepeatOption
} from '../store/calendar.types';

@Injectable()
export class CalendarService {
  constructor(private readonly http: HttpClient) {}

  public fetchEvents(props: fetchEventsProps): Observable<Event[]> {
    return this.http.post<Event[]>(`${environment.BACKEND_URL}/calendar/events`, props);
  }

  public fetchUnscheduledEvents(): Observable<UnscheduledEvents> {
    return this.http.post<UnscheduledEvents>(`${environment.BACKEND_URL}/calendar/unscheduledevents`, {});
  }

  public fetchOrgans(): Observable<Organ[]> {
    return this.http.get<Organ[]>(`${environment.BACKEND_URL}/calendar/organs`);
  }

  public fetchNewEventOrgans(): Observable<NewEventOrgan[]> {
    return this.http.get<NewEventOrgan[]>(`${environment.BACKEND_URL}/organs`);
  }

  public updateSelectedOrgans(organs: number[]): Observable<Organ[]> {
    return this.http.post<Organ[]>(`${environment.BACKEND_URL}/calendar/organs`, organs);
  }

  public addEvent(event: NewEvent): Observable<Event[]> {
    return this.http.post<Event[]>(`${environment.BACKEND_URL}/calendar`, event);
  }

  public removeEvents(data: string[]): Observable<void> {
    return this.http.delete<void>(`${environment.BACKEND_URL}/calendar/events`, {
      body: data
    });
  }

  public fetchRepeatOptions(props: FetchRepeatOptionsProps): Observable<RepeatOption[]> {
    return this.http.post<RepeatOption[]>(`${environment.BACKEND_URL}/calendar/events/repeatoptions`, props);
  }

  public fetchExternalOptions(props: FetchExternalOptionsProps): Observable<ExternalOptions> {
    return this.http.post<ExternalOptions>(`${environment.BACKEND_URL}/calendar/events/externaloptions`, props);
  }

  public fetchUserCanCreateMeeting(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.BACKEND_URL}/calendar/permissions/events/create`);
  }

  public fetchUserCanSeeUnscheduledEvents(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.BACKEND_URL}/calendar/permissions/events/unscheduled`);
  }

  public fetchNewEventCanHaveASecondMeetingDate(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.BACKEND_URL}/calendar/permissions/events/secondmeetingdate`);
  }
}
